const getDocumentElement = (): HTMLElement => {
  return window.navigator.userAgent.match(/MSIE (9|10)\./)
    ? document.body
    : document.documentElement;
};

const init = (onResize: (height: number) => void, interval: number): void => {
  const elm = getDocumentElement();
  // This fix is caused by later loaded la-hyper: Use temporary window.innerHeight to compare if a resize is needed.
  // (window.innerHeight is controlled from parent host page)
  // If la-hyper is not loaded yet, the resize event will be missed. For this it has to be sent several times.
  // Risk: if la-hyper fails to resize for any reason, the event will be broadcast endlessly.
  // https://axelspringer.atlassian.net/browse/LA-1931

  if (elm.offsetHeight > 0 && window.innerHeight !== elm.offsetHeight) {
    onResize(elm.offsetHeight);
  }

  const timerId = window.setInterval(() => {
    // TODO: use a GlobalContext flag for showOverlay
    const overlay = document.getElementsByClassName("overlay");
    const height = overlay.length === 1 ? elm.scrollHeight : elm.offsetHeight;

    if (height > 0 && window.innerHeight !== height) {
      onResize(height);
    }
  }, interval);

  window.addEventListener("unload", () => {
    window.clearInterval(timerId);
  });
};

export default {
  init,
};
